import React from 'react'
import './passwordVerifyContent.scss'
import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { useForm } from 'react-hook-form'
import ButtonLoading from '../buttonLoading/buttonLoading'
import Button from '../../../shared/components/atoms/Button/Button'
import {
	localStorage,
	sessionStorage,
} from '../../../shared/state/utils/storage'
import * as constants from '../../../shared/state/constants/appConstants'
import { RECOVERY_PASSWORD_AUTH } from '../../../shared/state/constants/apiConstants'
import SessionService from '../../../shared/services/session'
import { isAdviser } from '../../../shared/state/utils/isAdviser'
import { axiosInstance } from '../../../shared/services/axiosInstance'

const PasswordVerifyContent = props => {
	const {
		handleSubmit,
		errors,
		register,
		formState,
		triggerValidation,
	} = useForm()
	const [values, setValues] = React.useState({})
	const [isIncorrectPassword, setPassStatus] = React.useState(false)
	const [isLoaderVisible, setLoaderVisible] = React.useState(false)
	// const isShowingLoader = false;
	const passwordRef = React.useRef()
	const onSubmit = data => {
		setLoaderVisible(true)

		const isUserAdviser = isAdviser(SessionService.getIdTokenData())
		const config = {
			headers: {
				Authorization: SessionService.getIdTokenData(),
			},
		}

		console.log(SessionService.getUserData().email)

		const payload = {
			email: SessionService.getUserData().email,
			isCrm: isUserAdviser,
			password: data.password,
		}

		axiosInstance.post(RECOVERY_PASSWORD_AUTH, payload, config).then(res => {
			const { data } = res
			if (data.status === constants.successStatus) {
				props.actualStorage === 0
					? localStorage.setItem('tokenData', data.data.tokenData)
					: sessionStorage.setItem('tokenData', data.data.tokenData)
				props.handleNextSlider()
				props.handleSetRef(passwordRef)
			} else if (data.status === constants.failureStatus) {
				setValues({ ...values, passwordErrorMsg: data.userMessage })
				setPassStatus(true)
			}
			setLoaderVisible(false)
		})
	}

	const handleChange = () => event => {
		triggerValidation({ name: event.target.name })
		if (event.target.name === 'password') {
			setValues({ ...values, [event.target.name]: event.target.value })
			setPassStatus(false)
		}
	}

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword })
	}

	const handleMouseDownPassword = event => {
		event.preventDefault()
	}

	return (
		<div className='f-password-wrapper'>
			<h3 className='f-password-title'>CAMBIAR CONTRASEÑA</h3>
			<p className='f-password-subtitle'>
				Para continuar, primero debes verificar que eres tú
			</p>
			<form onSubmit={handleSubmit(onSubmit)}>
				<TextField
					error={
						errors.password != null ||
						(isIncorrectPassword && formState.isSubmitted)
					}
					color='secondary'
					name='password'
					className='f-form-input'
					id='f-password-input'
					variant='outlined'
					type={values.showPassword ? 'text' : 'password'}
					onChange={handleChange()}
					label={'Ingresa tu contraseña'}
					ref={passwordRef}
					helperText={
						errors.password && errors.password.type === 'required'
							? 'Una contraseña es requerida'
							: isIncorrectPassword &&
							  formState.isSubmitted &&
							  values.passwordErrorMsg
					}
					inputRef={register({ required: true, minLength: 3 })}
					InputProps={{
						endAdornment: (
							<InputAdornment position='end'>
								<IconButton
									edge='end'
									aria-label='toggle password visibility'
									onClick={handleClickShowPassword}
									onMouseDown={handleMouseDownPassword}
								>
									{values.showPassword ? (
										<VisibilityOff className='f-btn-password' />
									) : (
										<Visibility className='f-btn-password' />
									)}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
				{/* <ButtonLoading isEnabled={!(formState.isValid && formState.touched.includes('password'))} */}
				<ButtonLoading
					isEnabled={false}
					button={
						<Button
							id='f-changepass-submit-btn'
							type='input'
							classname='f-button f-button--primary'
							text='Siguiente'
						/>
					}
					isShowingLoader={isLoaderVisible}
					bgClass='primary'
				/>
			</form>
		</div>
	)
}

export default PasswordVerifyContent
